import React, { useState, useCallback, useMemo, useRef, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import { useSelector } from 'react-redux';
import claimEmployeeRndApportionmentsService from '../../services/claim/claim_employee_rnd_apportionments.service';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import ApportionmentsList from '../ApportionmentsList';
import paymentsToClinicalTrialsService from '../../services/claim/payments_to_clinical_trials.service';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
export function PaymentsToClinicalTrialsRow(_ref) {
  let {
    sortedClaimProjectReports,
    index,
    claim,
    handleDelete,
    paymentsToClinicalTrials,
    setPaymentsToClinicalTrials,
    refreshClaim,
    handleError,
    headerScrollPosition,
    isShowInvolvement
  } = _ref;
  const [hasError, setHasError] = useState(false);
  const user = useSelector(state => state.auth.user);
  const claimEmployeeRndApportRef = useRef(null);
  const paymentsToClinicalTrial = useMemo(() => {
    return {
      ...paymentsToClinicalTrials[index]
    };
  }, [paymentsToClinicalTrials, index]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (claimEmployeeRndApportRef.current) {
      claimEmployeeRndApportRef.current.scrollTo({
        left: headerScrollPosition
      });
    }
  }, [claimEmployeeRndApportRef, headerScrollPosition]);
  const updatepaymentsToClinicalTrials = useCallback(paymentsToClinicalTrial => {
    const newpaymentsToClinicalTrials = [...paymentsToClinicalTrials];
    newpaymentsToClinicalTrials[index] = {
      ...paymentsToClinicalTrial
    };
    setPaymentsToClinicalTrials([...newpaymentsToClinicalTrials]);
  }, [paymentsToClinicalTrials, index, setPaymentsToClinicalTrials]);
  const handleApportionmentChange = useErrorHandling(useCallback(async (paymentsToClinicalTrial, apportionment) => {
    const oldApportionment = paymentsToClinicalTrial.claim_employee_rnd_apportionments.find(a => a.claim_project_report_id === apportionment.claim_project_report_id);
    const index = paymentsToClinicalTrial.claim_employee_rnd_apportionments.indexOf(oldApportionment);
    const newApportionments = [...paymentsToClinicalTrial.claim_employee_rnd_apportionments];
    if (index === -1) {
      newApportionments.push(apportionment);
    } else {
      newApportionments[index] = {
        ...apportionment
      };
    }
    const updatedpaymentsToClinicalTrial = await paymentsToClinicalTrialsService.get(paymentsToClinicalTrial);
    updatedpaymentsToClinicalTrial.claim_employee_rnd_apportionments = newApportionments;
    updatepaymentsToClinicalTrials(updatedpaymentsToClinicalTrial);
  }, [updatepaymentsToClinicalTrials]));
  const handleChange = useCallback(event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    paymentsToClinicalTrial[event.target.name] = value;
    updatepaymentsToClinicalTrials(paymentsToClinicalTrial);
  }, [updatepaymentsToClinicalTrials, paymentsToClinicalTrial]);
  const saveChange = useCallback(() => {
    let method;
    if (paymentsToClinicalTrial.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    paymentsToClinicalTrialsService[method](paymentsToClinicalTrial).then(updatedpaymentsToClinicalTrial => {
      setHasError(false);
      updatepaymentsToClinicalTrials(updatedpaymentsToClinicalTrial);
      refreshClaim();
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [updatepaymentsToClinicalTrials, paymentsToClinicalTrial, dispatch, refreshClaim]);
  const hasPermissions = () => {
    return user.account_type !== 'customer' && user.account_type !== 'accountant';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: hasError ? 'bg-warning' : ''
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions(),
    name: "name",
    object: {
      ...paymentsToClinicalTrial,
      claim: {
        ...claim,
        ...paymentsToClinicalTrial.claim
      }
    },
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked || !hasPermissions(),
    name: "net_amount",
    object: {
      ...paymentsToClinicalTrial,
      claim: {
        ...claim,
        ...paymentsToClinicalTrial.claim
      }
    },
    size: "sm",
    type: "text"
  })), claim.claim_group.project_methodology === 'project_basis' && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ApportionmentsList, {
    claim: claim,
    sortedClaimProjectReports: sortedClaimProjectReports,
    headerScrollPosition: headerScrollPosition,
    claimEmployeeRndApportRef: claimEmployeeRndApportRef,
    handleApportionmentChange: handleApportionmentChange,
    claimEmployeeRndApportionmentsService: claimEmployeeRndApportionmentsService,
    model: paymentsToClinicalTrial,
    apportionmentable_type: "UkSection::PaymentsToClinicalTrial",
    isShowInvolvement: isShowInvolvement
  })), isShowInvolvement && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    object: {
      ...paymentsToClinicalTrial,
      claim: {
        ...claim,
        ...paymentsToClinicalTrial.claim
      }
    },
    disabled: claim.financials_locked || user.account_type === 'customer',
    name: "direct_rnd_apportionment",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    object: {
      ...paymentsToClinicalTrial,
      claim: {
        ...claim,
        ...paymentsToClinicalTrial.claim
      }
    },
    disabled: claim.financials_locked || user.account_type === 'customer',
    name: "indirect_rnd_apportionment",
    type: "text",
    size: "sm"
  }))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: !hasPermissions() || claim.claim_group.project_methodology === 'project_basis',
    name: "rnd_apportionment",
    object: {
      ...paymentsToClinicalTrial,
      claim: {
        ...claim,
        ...paymentsToClinicalTrial.claim
      }
    },
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    disabled: true || !hasPermissions(),
    name: "rnd_amount",
    object: {
      ...paymentsToClinicalTrial,
      claim: {
        ...claim,
        ...paymentsToClinicalTrial.claim
      }
    },
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, hasPermissions() && /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "secondary",
    disabled: claim.is_locked || claim.financials_locked || claim.active_change_set,
    style: {
      height: '28px'
    },
    onClick: handleDelete
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons text-danger"
  }, "delete")))));
}